import $ from "jquery";
import { smoothscroll } from "../utils/smoothscroll";
import { debounce } from "../utils/functions";

const $window = $(window);

const placeList = (element, index) => {
  if (index > 0) {
    element.remove();
  } else {
    const filter = {
      page: 1,
      limit: element.data("limit"),
      showPagination: element.data("showpagination"),
      categories: element.data("categories"),
      search: "",
      days: "",
      selectedCategories: [],
      lang: element.data("lang"),
    };

    bindPagination(element, filter);
    bindPlaceFilter(element, filter);
  }
};

const reRenderList = async (element, filter, scrollTop = false) => {
  $window.trigger("loader:show");
  const data = await getPlaces(filter);
  element.find(".place-list__content").html(data.html);
  $window.trigger("loader:hide");

  if (scrollTop === true) {
    smoothscroll(element, "header");
  }
};

const bindPagination = (element, filter) => {
  element.off("click", ".pagination__item");
  element.on("click", ".pagination__item", function () {
    filter.page = $(this).data("page");
    reRenderList(element, filter, true);
  });
};

const bindPlaceFilter = (element, filter) => {
  element.off("input", 'input[name="place-filter-input-search"]');
  element.on(
    "input",
    'input[name="place-filter-input-search"]',
    debounce(function () {
      const $input = $(this);
      filter.page = 1;
      filter.search = $input.val();

      const url = new URL(window.location);
      if (filter.search) {
        $input.parent().addClass("has-value");
        url.searchParams.set("place_search", filter.search);
      } else {
        $input.parent().removeClass("has-value");
        url.searchParams.delete("place_search");
      }
      window.history.replaceState({}, "", url);

      reRenderList(element, filter);
    })
  );

  element.off("change", 'select[name="select-post-days"]');
  element.on("change", 'select[name="select-post-days"]', function () {
    const $input = $(this);
    filter.page = 1;
    filter.days = $input.val();
    reRenderList(element, filter);
  });

  element.off("change", 'input[name="options[]"]');
  element.on("change", 'input[name="options[]"]', function () {
    const $checkboxes = element
      .find('input[name="options[]"]')
      .filter(function () {
        return $(this).prop("checked") === true;
      });

    const url = new URL(window.location);
    let ids = [];
    if ($checkboxes.length) {
      $checkboxes.each(function () {
        ids.push($(this).val());
      });
      url.searchParams.set("place_categories", ids.join(","));
    } else {
      url.searchParams.delete("place_categories");
    }
    window.history.replaceState({}, "", url);

    filter.page = 1;
    filter.selectedCategories = ids;
    reRenderList(element, filter);
  });

  element.off("click", 'button[name="place-filter-input-reset"]');
  element.on("click", 'button[name="place-filter-input-reset"]', () => {
    element
      .find('input[name="place-filter-input-search"]')
      .val("")
      .trigger("input");
  });

  const url = new URL(window.location);
  let initialCategories = url.searchParams.get("place_categories");
  if (initialCategories) {
    initialCategories = initialCategories.split(",");
    const $checkboxes = element
      .find('input[name="options[]"]')
      .filter(function () {
        return initialCategories.includes($(this).val());
      });
    $checkboxes.prop("checked", true).trigger("change");
  }
  const initialSearch = url.searchParams.get("place_search");
  if (initialSearch) {
    element
      .find('input[name="place-filter-input-search"]')
      .val(initialSearch)
      .trigger("input");
  }
};

const getPlaces = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + "/wp-json/vuvh/v1/place-list/html",
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const reloadScriptPlaceList = () => {
  const $element = $(".place-list");

  $element.each(function (index) {
    placeList($(this), index);
  });
};
reloadScriptPlaceList();
